import type { S3File } from "./S3File.js";

export function getExtensionOfS3File(file: S3File): string {
	return file.path.split(".").filter(Boolean).slice(1).pop() ?? file.type;
}
